import React from 'react';
import { ColorMode } from '../../../../../core/interfaces/color-mode';
import { ButtonWrapper } from '@hevoio/hevo-ui-toolkit';
import { useActiveTheme } from '../../../../../theming/hooks/themeProvider';
import styles from './BigQueryManageWarehouseCard.module.scss';

export default function BigQueryManageWarehouse({ actionHandler }) {
  const colorMode = useActiveTheme();

  const onFocusCallback = event => {
    const childTile = event.target.querySelector('[data-id="bgquery-node-inner"]');
    if (childTile) {
      childTile.focus();
    }
  };

  return (
    <>
      <div className={`col-lg-1 ${styles.dividerWrapper}`}>
        <div className={styles.verticalRow} />
        <div className={styles.or}>OR</div>
        <div className={styles.verticalRow} />
      </div>

      <ButtonWrapper
        type='button'
        className={styles.cardWrapper}
        onClick={actionHandler}
        onFocus={onFocusCallback}
      >
        <div tabIndex={0} role='button' className={styles.entityCard} data-id='bgquery-node-inner'>
          <span className={`mt-1 ${styles.title}`}>Don't have a Warehouse?</span>

          <div className={styles.entityCardImgContainer}>
            <img
              src='https://res.cloudinary.com/hevo/image/upload/v1613498516/glyphs/Managed_Warehouse_vyl8ph.svg'
              alt='warehouse'
            />
            <div className={styles.entityCardImgBg} />
          </div>

          <span className={styles.entityCardName}>Set up Hevo Managed Warehouse</span>

          <div className={styles.poweredBy}>
            <span className='mr-5'>Powered by</span>
            <img
              width='84'
              src={
                colorMode === ColorMode.DARK
                  ? 'https://res.cloudinary.com/hevo/image/upload/v1663070886/Google_bigquery_dark_mode_logo_dp3yql.png'
                  : 'https://res.cloudinary.com/hevo/image/upload/w_100/v1613541539/glyphs/bq-full_xk3qqn.png'
              }
              alt='powered'
            />
          </div>
        </div>
      </ButtonWrapper>
    </>
  );
}
